import React from 'react';
import { withRouter } from 'react-router-dom';
import Hotkeys from 'react-hot-keys';

import CodeMirror from 'react-codemirror';

import { Button, Card, Col, Icon, Input, message, Row, Popconfirm, Modal, Switch, Tag } from 'antd';

import {
	_getDataReport, 
	_postDeleteDataReport, 
	_postSaveDataReport, 
	_postShareDataReport, 
	_postRemoveShareDataReport, 
	_downloadDataReport
} from '../../services';

import { API_ENDPOINT } from '../../index';

import "./editor.css";
import "codemirror/mode/javascript/javascript";
import "codemirror/lib/codemirror.css";

const csvScriptText = `// setup. No need to edit unless you know your stuff well.
let csvStream = csv.createWriteStream({headers: true, quoteColumns: true});

csvStream.on("finish", () => {
	console.log("Done");
});

csvStream.pipe(res);

/**
 * START CODING HERE
 **/

// do work and write to stream
csvStream.write({
	title: "test",
	modelNumber: "test 2",
	price: "test 3",
	supplier: "test 4"
});

// when work is finished, end stream
csvStream.end();`

const xlsxScriptText = `


/**
 * Workbook Definitions
 **/

// Sheet 1 (Duplicate as needed)
const columns = [
	{ header: 'Col1', key: 'Col1' },
	{ header: 'Col2', key: 'Col2' },
]
const sheet = excelWorkbook.addWorksheet('My First Sheet')
sheet.columns = columns

// Sheet 2 (Duplicate as needed)
/**
const columns2 = [
  { header: 'Col3', key: 'Col3'},
  { header: 'Col4', key: 'Col4'},
]
const sheet2 = excelWorkbook.addWorksheet('My Second Sheet')
sheet2.columns = columns2
**/

/**
 * START CODING HERE
 **/

q.all([
	events._query("SELECT DISTINCT EVENT_TYPE FROM SITE_EVENTS")
])
	.then(([_events]) => {

		_events.map(_event => {
			sheet.addRow({
				'Col1': _event.event_type,
				'Col2': 'world'
			})
		})

		return Promise.resolve()
	})
	.then(() => {
		/**
		 * DO NOT REMOVE THIS SECTION
		 **/

		return excelWorkbook.xlsx.writeFile(res)
			.then(() => {
				// Check file size
				var stats = fs.statSync(res)
				var fileSizeInBytes = stats["size"]
				var fileSizeInMegabytes = fileSizeInBytes / 1000000.0

				const email = new Email({ from: 'Eezee System', to: userEmail })

					return gStorage
						.bucket("eezee-data-reports")
						.upload(res, {
							public: true,
							metadata: {
								cacheControl: 'public, max-age=25920000'
							}
						})
						.then((_gStorage) => {

							const downloadLink = _gStorage[1].mediaLink
							console.log('going to send as link')
                      		// Creates and sends Link of Data Report to User
							return q.all([
                              email.sendDataReportLink({ dataReportName, downloadLink })
                              .then(() => fs.unlink(res, (err) => {
                                  if (err) {throw err}
                                  console.log('unlink is successful!')
                               })),
                              // Creates a dateReportDownload Log
                              dataReportDownload.downloadComplete({link: downloadLink})
                            ])
						})

				/**
				* END OF DO NOT REMOVE THIS SECTION
				**/
			})
	})
	.catch(err => {
  		console.log(err)
  		dataReportDownload.downloadError({errorMsg: err})
	})

  
  /**
   * END CODING HERE
   **/
  

`

class DataReportEditor extends React.Component{

	
	render(){

		const version = this.state.dataReport.version
		
		if( this.state.loading ){
			return "loading...";
		}

		return (
			<Hotkeys keyName="shift+command+s,shift+ctrl+s" onKeyDown={this.handleEscapeHotkeys} onKeyUp={ this.handleHotkeys}>
				{this.state.renderShareModal &&
				<Modal
					afterClose={()=>this.setState({
						renderShareModal: false
					})}
					onCancel={()=>this.setState({
						shareModalVisible: false
					})}
					title="Share this data report with..."
					centered
					footer={null}
					visible={this.state.shareModalVisible}
				>
					<Input
						placeholder="email..."
						onPressEnter={this.handleShare}
					/>
					{this.state.dataReport.sharedWith.map( _email => (
						<Row type="flex" justify="space-between" style={{marginTop: 12}}>
							<Col>
								<Icon type="user"/> <span style={{marginLeft: 8}}>{_email}</span>
							</Col>
							<Col>
								<a
									onClick={()=>this.handleRemoveShare(_email)}
								>Remove</a>
							</Col>
						</Row>
					))}
				</Modal>}
				<Card title={(

					<Row type="flex" justify="space-between">
						<Col>
							<Button href="/data-reports">
								<Icon type="left" />
								Data Reports
							</Button>
						</Col>
						<Col>
							<Row type="flex" gutter={8}>

								{!(version && version.major) >= 2 &&
								<Col><Tag color="geekblue">CSV</Tag></Col>
								}
								
								<Col>
									<Popconfirm title="Are you sure you want to delete this script? This action is not reversible." onConfirm={ this.handleDeleteDataReport }>
										<Button type="danger">
											Delete
										</Button>
									</Popconfirm>
								</Col>

								<Col>
									<Button onClick={this.openShareModal}>
										Share
									</Button>
								</Col>
								
								{
									this.state.dataReport._id && (
										<Col>
											{
												(version && version.major >= 2) ?
													<Button onClick={() => this.handleDownloadClick(this.state.dataReport._id)}>Download2</Button>
													:
													<Button
														href={`${API_ENDPOINT}/api/admin/data-report/process/${this.state.dataReport._id}`}
														target='_blank'>
														Download</Button>
											}
										</Col>
									)
								}

								<Col>
									<Button type="primary" onClick={ this.handleSaveDataReport }>
										Save [SHIFT + CTRL + S]
									</Button>
								</Col>
							</Row>
						</Col>
					</Row>

				)}>

					<Row type="flex" >
						<Col>
							<h3>Name:</h3>
							<Input 
								value={ this.state.dataReport.name }
								onChange={ (e) => this.updateDataReportValue({ 
									"field": "name", 
									"value": e.target.value
								})}
								style={{ width: 300}} />
						</Col>
					</Row>

					<div style={{ marginTop: 32 }}>
						<h3>Description:</h3>
						<Input.TextArea
							onChange={ (e) => this.updateDataReportValue({ 
								"field": "description", 
								"value": e.target.value
							})}
							value={this.state.dataReport.description} style={{ width: 600 }} rows={4} />
					</div>

					<div style={{ marginTop: 32 }}>
						<h3>The Script:</h3>

						<CodeMirror 
							value={this.state.dataReport.scriptText} 
							onChange={this.updateScriptText} 
							options={{
								viewportMargin: Infinity,
								lineNumbers: true,
								mode: "javascript"
							}} />
						
						{/* <Input.TextArea value={ this.state.dataReport.scriptText } onKeyDown={ this.handleOnKeyDown } style={{ width: 800 }} rows={100} /> */}
					</div>

				</Card>
			</Hotkeys>
		)
	}

	constructor( props ){

		super(props);

		this.state = {
			loading: true,
			dataReport: {
				sharedWith: [],
				name: "",
				description: "",
				scriptText: xlsxScriptText, 
			},
			dataReportLoaded: false
		}

		
	}
	
	componentDidMount(){
		
		if( this.props.match.params.dataReportId ){
				
			_getDataReport( this.props.match.params.dataReportId )
				.then( res => {
					this.setState({ loading: false, dataReportLoaded: true, dataReport: res.data.dataReport })
				})
	
		} else {
			this.setState({ loading: false, dataReportLoaded: true });
		}
	}

	// handleEscapeHotkeys = ( keyNm, e, handle ) => {

	// 	e.preventDefault();
		
	// 	return false;

	// }
	openShareModal = () => {
		this.setState({
			renderShareModal: true,
			shareModalVisible: true
		})
	}

	handleRemoveShare = (email) => {

		const { dataReportId } = this.props.match.params
		
		_postRemoveShareDataReport({ email, dataReportId })
		.then( res => {
			this.setState({
				dataReport: {...this.state.dataReport,
					sharedWith: res.data.dataReport.sharedWith
				}
			})
		})
	}

	handleShare = (e) => {

		const email = e.target.value

		const { dataReportId } = this.props.match.params

		_postShareDataReport({email, dataReportId})
		.then( res => {
			this.setState({
				dataReport: {...this.state.dataReport,
					sharedWith: res.data.dataReport.sharedWith
				}
			})
		})
	}

	handleDeleteDataReport = ( ) => {

		if( !this.state.dataReport._id ){
			message.destroy();
			message.error("Can't delete what you didn't save!");
			return false;
		}

		_postDeleteDataReport( this.state.dataReport._id )
			.then( res => {

				this.props.history.push('/data-reports/');

			})

	}

	handleHotkeys = (keyNm, e, handle) => {

		e.preventDefault();

		this.handleSaveDataReport();
		return false;

	}

	handleSaveDataReport = () => {

		let loader = message.loading("Saving data report...", 0 );

		if( !this.state.dataReport.name || !this.state.dataReport.description || !this.state.dataReport.scriptText ){
			message.destroy();
			return message.error("All fields are required!");
		}

		_postSaveDataReport( this.state.dataReport )
			.then( res => {

				loader();
				message.success("Data report saved!");

				this.props.history.push(`/data-reports/${res.data.dataReport._id}`)

				this.setState({
					dataReport: res.data.dataReport
				});

			})
	}

	handleDownloadClick = (dataReportId) => {

		_downloadDataReport({dataReportId})
		.then(()=> console.log('success'))

		return Modal.info({
			centered: true,
			title: "Data Report",
			content: "The Data Report will be sent to your email once it's ready"
		})
	}

	updateDataReportValue = ({ field, value }) => {
		this.setState({
			dataReport: {
				...this.state.dataReport,
				[field]: value
			}
		})
	}

	updateScriptText = ( scriptText ) => {

		this.setState({
			dataReport: {
				...this.state.dataReport,
				scriptText
			}
		});

	}

}

export default withRouter(DataReportEditor);


// WEBPACK FOOTER //
// ./src/components/data-report/editor.js